import { useQuery } from '@tanstack/react-query';

import React, { useEffect, useState } from 'react';
import {
  getAllBillings,
  getAllPaymentHistory,
  getInvoice
} from '../../../services/api/implementation/impl';
import Table from '../../../../shared/components/layout/Table';
// import { IconList } from "../../utils/IconList";
import searchIcon from '../../../../shared/assets/svg/search.svg';
import filterIcon from '../../../../shared/assets/svg/filter.svg';
import reverseIcon from '../../../../shared/assets/svg/reverse.svg';

import { transformData } from '../../../utils/transformData';
import GridWrapper from '../../../../shared/components/layout/GridWrapper';

// import payments from '../../../static/payments.json';
import toast from 'react-hot-toast';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const PaymentHistory = ({ onChangePaymentId }) => {
  // const { data: payments, refetch: refetchInvoice } = useQuery({
  //   queryKey: ["payments"],
  //   queryFn: () => getInvoice(),
  // });

  const userId = Cookies.get('userId');

  // Track page view
  useEffect(() => {
    mixpanel.track('Super Admin Payment History Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  /* 
    Meta data
  */
  const paymentFormat = [
    'id',
    'invoice_number',
    'project_name',
    'amount',
    'amount_paid',
    'created_at',
    'actions'
  ];

  /* 
    Data fetching
  */
  const { data: payments } = useQuery({
    queryKey: ['payment'],
    queryFn: getAllPaymentHistory,
    onSuccess: (result) => {
      // Check if result is an error object
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        mixpanel.track('Super Admin Payment History Fetch Failed', {
          user_id: userId,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        toast.error(
          result?.response?.data?.message || result?.message || 'Failed to fetch payment history'
        );
        return;
      }

      mixpanel.track('Super Admin Payment History Fetch Success', {
        user_id: userId,
        payments_count: result?.length || 0,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err) => {
      mixpanel.track('Super Admin Payment History Fetch Failed', {
        user_id: userId,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
      toast.error(
        err?.response?.data?.message || err?.message || 'Failed to fetch payment history'
      );
    }
  });

  console.log('Payments: ', payments);

  /* 
    Effets
  */
  useEffect(() => {
    // toast.success(`Successfully fetched ${payments?.length} payments`);
  }, [payments?.length]);

  /* 
    Helper method calls
  */

  //const transformedData = payment?.length && payment?.map((el) => transformData(el, InvoiceDataFormat));
  const transformedData =
    payments &&
    payments?.length > 0 &&
    payments?.map((el) =>
      transformData(
        {
          id: el?.id,
          invoice_number: el?.invoice?.invoice_number,
          project_name: el?.invoice?.project.name,
          amount_paid: el?.amount,
          created_at: el?.created_at,
          amount: el?.invoice?.amount
        },
        paymentFormat
      )
    );
  /////////////////////////////////////---------------------------------------------

  const [searchQuery, setSearchQuery] = useState('');
  const [reverseOrder, setReverseOrder] = useState(false);

  const filteredData =
    transformedData &&
    transformedData?.length > 0 &&
    transformedData?.filter((row) =>
      // console.log("rowwww", row)
      row.customer_name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

  if (reverseOrder) {
    filteredData.reverse();
  }

  const handleSearchChange = (e) => {
    mixpanel.track('Super Admin Payment History Search', {
      user_id: userId,
      search_query: e.target.value,
      timestamp: new Date().toISOString()
    });
    setSearchQuery(e.target.value);
  };

  const handleReverseOrderChange = () => {
    mixpanel.track('Super Admin Payment History Order Reversed', {
      user_id: userId,
      new_order: !reverseOrder ? 'reversed' : 'normal',
      timestamp: new Date().toISOString()
    });
    setReverseOrder(!reverseOrder);
  };

  const handleInvoiceFilter = (e) => {
    mixpanel.track('Super Admin Payment History Filter Clicked', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
    // OpenModal(e);
    // setmodalWidth(26);
    // setmodalHeight(22);
  };

  const handlePaymentEdit = (id) => {
    mixpanel.track('Super Admin Payment Edit Clicked', {
      user_id: userId,
      payment_id: id,
      timestamp: new Date().toISOString()
    });
    onChangePaymentId(id);
  };

  return (
    <div className="overflow-y-auto pt-3">
      <div className="h-[31rem] p-6">
        <Table
          headers={[
            'Invoice no.',
            'Project Name',
            'Invoice value',
            'Amount paid',
            'Payment date',
            'Actions'
          ]}
          data={transformedData}
          identifier={'id'}
          onEdit={handlePaymentEdit}
        />
      </div>
    </div>
  );
};

export default PaymentHistory;
